import React, { useCallback, useState, useEffect } from 'react'
import { Datagrid } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import { navigate, useParams } from '@reach/router'
import { useDispatch } from 'react-redux'
import { ROUTES } from '_/utils/constants'
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core'
import { ColumnsWebhookRequests } from '../constants'
import { getWebhookQueue, getWebhooksByAgency } from '_/modules/agency/actions'
import useStyles, { datagridStyle } from './styles'

const WebhookRequests = () => {
  const styles = useStyles()
  const { agencyId, webhookId } = useParams()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [requests, setRequests] = useState([])
  const [jsonModalOpen, setJsonModalOpen] = useState(false)
  const [selectedJson, setSelectedJson] = useState('')

  const handleBackNavigation = useCallback(() => {
    return navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.WEBHOOK_LIST}`)
  }, [navigate, agencyId])

  const handleCellClick = useCallback((params, event) => {
    if (params.field === 'json_sent') {
      event.stopPropagation()
      setSelectedJson(params.row.json_sent || '')
      setJsonModalOpen(true)
    }
  }, [])

  const handleCloseJsonModal = useCallback(() => {
    setJsonModalOpen(false)
    setSelectedJson('')
  }, [])

  const fetchWebhookRequests = useCallback(() => {
    setIsLoading(true)
    dispatch(getWebhookQueue(webhookId))
      .then(data => {
        dispatch(getWebhooksByAgency({ agency: agencyId }))
          .then(webhooksData => {
            const webhookExists = webhooksData?.results?.some(
              webhook => webhook.id?.toString() === webhookId?.toString()
            )
            if (!webhookExists) {
              navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.WEBHOOK_LIST}`)
              return
            }
            setRequests(data?.results || [])
            setIsLoading(false)
          })
          .catch(() => {
            navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.WEBHOOK_LIST}`)
          })
      })
      .catch(() => {
        setIsLoading(false)
        navigate(`${ROUTES.AGENCY}/${agencyId}${ROUTES.WEBHOOK_LIST}`)
      })
  }, [dispatch, webhookId, agencyId])

  useEffect(() => {
    fetchWebhookRequests()
  }, [fetchWebhookRequests])

  return (
    <>
      <HeaderTitle title="Requisições" backButtonAction={handleBackNavigation} />
      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            loading={isLoading}
            rows={requests}
            columns={ColumnsWebhookRequests()}
            paginationMode="server"
            sx={datagridStyle}
            onCellClick={handleCellClick}
            checkboxSelection={false}
            disableSelectionOnClick
            sortModel={[{ field: 'created_at', sort: 'desc' }]}
          />
        </Grid>
      </Grid>

      <Dialog open={jsonModalOpen} onClose={handleCloseJsonModal} maxWidth="md" fullWidth>
        <DialogTitle>Json enviado</DialogTitle>
        <DialogContent>
          <Typography
            component="pre"
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontFamily: 'monospace',
              fontSize: '14px',
              backgroundColor: '#f5f5f5',
              padding: '16px',
              borderRadius: '4px',
              maxHeight: '400px',
              overflow: 'auto',
            }}
          >
            {selectedJson}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseJsonModal} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default WebhookRequests
